<template>
  <!--常见问题页面-->
  <tk-container :status="status">
    <!--头部-->
    <my-header slot="header">常见问题</my-header>
    <!--内容-->
    <div style="height: 10px;"></div>
    <card :width="100" :height="50" class="p-0">
      <div class="help-box" v-if="commonProblem.length">
        <div
          v-for="(s, index) in commonProblem"
          :key="`help-box${index}`"
          @click="getWhether(s, index)"
          class="help-box-line"
        >
          <tk-flex between class="help-box-title">
            <tk-flex middle class="font-bold">
              <div
                class="box-title-image"
                :style="`background-image: url(${decoration}) !important`"
              >
                {{'Q' + (index + 1)}}
              </div>
              <div class="m-l-10">{{s.problem}}</div>
            </tk-flex>
            <div>
              <tk-icon size="16" v-if="s.whetherFold">uparrow</tk-icon>
              <tk-icon size="16" v-else>downarrow</tk-icon>
            </div>
          </tk-flex>
          <div v-html="s.answer" v-if="s.whetherFold" class="help-box-content p-x-12 m-b-12"></div>
        </div>
      </div>
    </card>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      decoration: 'https://s3.moke.cloud/dianpei/52acf359-3760-4e64-bc64-96f1dffacdf8.png',
      commonProblem: [] // 常见问题数据
    }
  },
  computed: {},
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
    * 初始化数据
    * @date: 2020/4/15
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        let res = await this.$tkParse.getList('/classes/commonProblem', {
          params: {
            order: 'createdAt'
          }
        })
        if (res.length) {
          this.commonProblem = res.map(s => {
            s.whetherFold = false
            return s
          })
          this.commonProblem[0].whetherFold = true
        } else {
          this.commonProblem = []
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 闭合收起答案
    * @date: 2020/4/15
    */
    getWhether (s, index) {
      s.whetherFold = !s.whetherFold
      this.commonProblem[index].whtherFold = s.whetherFold
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
  /*常见问题样式*/
  .help-box {
    .help-box-line {
      border-bottom: 1px solid #f5f5f5;
    }
    .help-box-title {
      padding: 12px;
      font-size: 15px;
      .box-title-image {
        width: 28px;
        height: 28px;
        color: #fff;
        font-size: 11px;
        line-height: 28px;
        font-weight: normal;
        text-align: center;
        background-repeat:  no-repeat;
        background-size: 100% auto;
      }
    }
    .help-box-content {
      font-size: 13px;
      color: rgba(102, 102, 102, 1);
    }
  }
</style>
